'use strict';

DoohApps.factory('SessionData', ['$location', '$route', '$interval', 'accountBLL', 'CompanyBLL', 'Hub', 'SessionHelper', 'User',
    function ($location, $route, $interval, accountBLL, CompanyBLL, Hub, SessionHelper, User) {
        var isLoggedIn = function () {
            if (_sessionActive)
                accountBLL.isAuthenticated(function (data) {
                    if (data == false) {
                        SessionHelper.clearSessionLocalStorage();
                        User.clear();
                        _sessionActive = false;
                        Hub.Stop();
                        $location.path('/');
                    } else {
                        _sessionActive = true;
                    }
                });
        }

        $interval(isLoggedIn, 20000, 0);
        var _sessionActive = false;
        var _returnURL = null;

        return {
            setLoginRequired: function (value) {
                sessionStorage['loginRequired'] = value;
            },
            loginRequired: function () {
                return sessionStorage['loginRequired'] === 'true'
            },
            setReturnURL: function () {
                _returnURL = $location.path();
            },
            getReturnURL: function () {
                return _returnURL;
            },
            clearReturnURL: function () {
                _returnURL = null;
            },
            corruptAuthToken: function () {
                localStorage.setItem('accessToken', 'b b b b b bird bird bird bbb b b b b bird bird bird');
            },
            corruptRefreshToken: function () {
                localStorage.setItem('refreshToken', 'the bird is the word, bbb bird bird bird');
            }
        }
    }]);